import axios, { AxiosRequestConfig } from 'axios'
import { apiBaseURL } from '../constants'
import { ACCESS_TOKEN_KEY } from '../constants'
import Cookie from 'js-cookie'

const http = axios.create({
    baseURL: apiBaseURL,
})

export const parseQuery = (q: string) => {
    if (q.startsWith('?')) q = q.slice(1);
    const res: Record<string, string> = {}
    const arr = q.split('&');
    for (let i of arr) {
        const [key, val] = i.split('=');
        res[key] = decodeURIComponent(val)
    }
    return res;
}

export const request = async <T>(url: string, config?: AxiosRequestConfig) => {
    let urlWithParams = url;
    const queryObj = { ...config?.params };
    for (let k in config?.params || {}) {
        if (urlWithParams.includes(`{${k}}`)) {
            delete queryObj[k]
            urlWithParams = urlWithParams.replace(`{${k}}`, config?.params[k])
        }
    }
    const res = await http<T>(urlWithParams, {
        ...config,
        params: queryObj,
        headers: {
            ...config?.headers,
            'Authorization': `Bearer ${Cookie.get(ACCESS_TOKEN_KEY)}`
        }
    })
    if ((res.data as any).code === 1001) {
        window.location.href = '/login?href=' + window.location.href;
    }
    if ((res.data as any).success === false) {
        throw new Error((res?.data as any)?.msg)
    }
    return res.data
}

export const dateRender = (date?: Date | string | number) => {
    if (!date) return ''
    const d = new Date(date)
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${d.getFullYear()}-${m}-${day}`
}

export const timeRender = (_date?: Date | string | number) => {
    if (!_date) return ''
    const date = new Date(_date);
    const hour = date.getHours().toString().padStart(2, "0");
    const minute = date.getMinutes().toString().padStart(2, "0");
    const second = date.getSeconds().toString().padStart(2, "0");
    return `${hour}:${minute}:${second}`
}
export const dateTimeRender = (date?: Date | string | number) => {
    return `${dateRender(date)} ${timeRender(date)}`

}

export const textRender = (text: Optional<string>) => text ? text : '-';

export const parseSearchParams = <T>(search: URLSearchParams) => {
    const res: { [key: string]: string } = {};
    search.forEach((val, key) => {
        res[key] = val
    })
    return res as T;
}

export const downloadFile = async (uri: string, payload?: any) => {
        const res = await http(uri, {
            responseType: 'blob',
            method: payload ? 'post' : 'get',
            data: payload ?? null,
            headers: {
                'Authorization': `Bearer ${Cookie.get(ACCESS_TOKEN_KEY)}`
            }
        });
        const { data, headers } = res
        const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
        const blob = new Blob([data], { type: headers['content-type'] })
        let dom = document.createElement('a')
        let url = window.URL.createObjectURL(blob)
        dom.href = url
        dom.download = decodeURI(fileName)
        dom.style.display = 'none'
        document.body.appendChild(dom)
        dom.click()
        dom.remove()
        window.URL.revokeObjectURL(url)
        return true
}

export const canISeeThis = (roles: UserRole[], authControl?: {
    rolesCanSee?: string[],
    rolesCanNotSee?: string[],
}) => {
    if (!authControl) return true;
    if (authControl.rolesCanNotSee) {
        if (roles.find(role => authControl.rolesCanNotSee!.some(roleName => roleName === role.name))) {
            return false
        } else {
            return true
        }
    } else if (authControl.rolesCanSee) {
        if (roles.find(role => authControl.rolesCanSee!.some(roleName => roleName === role.name))) {
            return true
        } else {
            return false
        }
    }
}